import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface TimesheetReportsHeaderProps {
    onSearch?: (value: string) => void;
    onBulkAction?: (action: string) => void;
}

const TimesheetReportsHeader: React.FC<TimesheetReportsHeaderProps> = ({ 
    onSearch,
    onBulkAction 
}) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState('');

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchValue(value);
        onSearch?.(value);
    };

    const handleBulkAction = (action: string) => {
        onBulkAction?.(action);
    };

    return (
        <div className="timesheet-reports-header">
            <h1 className="reports-header-title">{t('SHARED_REPORTS')}</h1>
            
            <div className="reports-header-actions">
                <div className="search-input-wrapper">
                    <svg className="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#68727D" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <input
                        type="text"
                        className="search-input"
                        placeholder={t('SEARCH')}
                        value={searchValue}
                        onChange={handleSearchChange}
                    />
                </div>

                <Dropdown className="bulk-action-dropdown">
                    {/* <Dropdown.Toggle variant="outline-secondary" className="bulk-action-btn">
                        {t('BULK_ACTION')}
                    </Dropdown.Toggle> */}

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleBulkAction('export')}>
                            {t('EXPORT_SELECTED')}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleBulkAction('delete')}>
                            {t('DELETE_SELECTED')}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => handleBulkAction('share')}>
                            {t('SHARE_SELECTED')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
};

export default TimesheetReportsHeader;
